module.exports = __webpack_public_path__ + "src/img/stylemarks/laptop-2.0c1be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stylemarks/laptop-2.jpg
// module id = 117
// module chunks = 0